(ns frontend.view.modals.nylas-connect.event
  (:require [frontend.view.modals.nylas-connect.model :as model]
            [re-frame.core :as rf]))

(rf/reg-event-fx
 ::init
 (fn [{db :db} [_ keep-private? sync-contacts? account-email]]
   {:db (assoc-in db model/root-path
                  {model/email-hint-path    account-email
                   model/keep-private?-key  keep-private?
                   model/sync-contacts?-key sync-contacts?})}))

(rf/reg-event-fx
 ::toggle-private?
 (fn [{db :db} [_ keep-private?]]
   {:db (assoc-in db model/keep-private?-full-path keep-private?)}))

(rf/reg-event-fx
 ::toggle-sync-contacts?
 (fn [{db :db} [_ sync-contacts?]]
   {:db (assoc-in db model/sync-contacts?-full-path sync-contacts?)}))

(rf/reg-event-fx
 ::set-email-hint
 (fn [{db :db} [_ value]]
   {:db (assoc-in db model/email-hint-full-path value)}))
